import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import useViewport from 'Hooks/useViewport';

const ProductEditionKeyPoints = ({
  keyPoints,
}) => {
  const [showMore, setShowMore] = useState(false);
  let showMoreButton = false;
  let showMoreTotal = 0;
  const { isXxl, isXl, isLg, isBelowLg } = useViewport();
  let keyPointsToDisplay = keyPoints;
  let displayLimit = 8;

  if (isXxl) displayLimit = 8;
  if (isXl) displayLimit = 6;
  if (isLg) displayLimit = 5;
  if (isBelowLg) displayLimit = 4;

  if (keyPoints.length > displayLimit && !showMore) {
    showMoreTotal = keyPoints.length - displayLimit;
    showMoreButton = true;
    keyPointsToDisplay = keyPointsToDisplay.slice(0, displayLimit);
  }

  return (
    <div className="ProductEditionCard__keyPointsContainer">
      {keyPointsToDisplay.map(point =>
        <div key={point} className="ProductEditionCard__keyPoint">
          <FontAwesomeIcon icon={faCheck} />
          <div className="ProductEditionCard__keyPointText">
            {point}
          </div>
        </div>,
      )}
      {showMoreButton &&
        <button className="ProductEditionCard__keyPointsShowMoreButton" onClick={() => setShowMore(true)}>+ {showMoreTotal} more</button>
      }
    </div>
  );
};


ProductEditionKeyPoints.propTypes = {
  keyPoints: PropTypes.arrayOf(PropTypes.string),
};

ProductEditionKeyPoints.defaultProps = {
  keyPoints: [],
};

export default ProductEditionKeyPoints;
